import { createFileRoute, redirect } from '@tanstack/react-router'
import { StatusCodes } from 'http-status-codes'

export const Route = createFileRoute('/(redirects)/preview/event/$eventId')({
  loader: ({ params }) => {
    throw redirect({ to: `/event/${params.eventId}`, statusCode: StatusCodes.MOVED_PERMANENTLY })
  },
})
